<template>
  <div
    v-if="order"
    class="d-inline-flex"
  >
    <div style="position: relative;">
      <v-tooltip
        v-if="parseInt(order.OrderTypeId) === OrderTypeEnum.COLLECTION && parseInt(order.SourceTypeId) !== SourceTypeEnum.TABLE"
        :color="'light-blue'"
        :disabled="!tooltip"
        content-class="text-center"
        right
      >
        <template #activator="{on}">
          <div
            class="d-inline-block"
            v-on="on"
          >
            <v-chip
              :class="chipClass"
              :small="dense"
              :style="`min-width: ${chipMinWidth}px;`"
              class="light-blue lighten-1 white--text elevation-0 pl-0"
              label
            >
              <v-avatar
                :style="avatarSize"
                class="light-blue darken-1 mr-2"
                tile
              >
                <v-icon
                  :size="iconSize"
                  color="light-blue lighten-4"
                >
                  {{ order.HasMpServiceWaiter ? 'mdi-room-service' : 'directions_run' }}
                </v-icon>
              </v-avatar>

              <div
                class="text-center"
                style="width: 100%;"
              >
                <span
                  v-if="label"
                  :class="{'mr-1': !hideTime}"
                >
                  {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
                </span>

                <template v-if="order.IsScheduled">
                  {{ scheduledOrderDate }} {{ order.ScheduledTimeAt }}
                </template>
                <template v-else-if="!hideTime">
                  {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
                </template>
              </div>
            </v-chip>
          </div>
        </template>

        <div v-if="order.IsScheduled">
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }} <br> {{ order.ScheduledDateAt }} {{ order.ScheduledTimeAt }}
        </div>
        <div v-else>
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
          <template v-if="!hideTime">
            <br> {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
          </template>
        </div>
      </v-tooltip>

      <v-tooltip
        v-if="parseInt(order.OrderTypeId) === OrderTypeEnum.DELIVERY"
        :color="'purple'"
        :disabled="!tooltip"
        content-class="text-center"
        right
      >
        <template #activator="{on}">
          <div
            class="d-inline-block"
            v-on="on"
          >
            <v-chip
              :class="chipClass"
              :small="dense"
              :style="`min-width: ${chipMinWidth}px;`"
              class="purple lighten-1 white--text elevation-0 pl-0"
              label
            >
              <v-avatar
                :style="avatarSize"
                class="purple darken-2 mr-2"
                tile
              >
                <v-icon
                  :size="iconSize"
                  class="purple--text text--lighten-3"
                >
                  {{ order.HasMpServiceDelivery ? 'mdi-moped' : 'directions_bike' }}
                </v-icon>
              </v-avatar>

              <div
                class="text-center"
                style="width: 100%;"
              >
                <span
                  v-if="label"
                  :class="{'mr-1': !hideTime}"
                >
                  {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
                </span>

                <template v-if="order.IsScheduled">
                  {{ scheduledOrderDate }} {{ order.ScheduledTimeAt }}
                </template>
                <template v-else-if="!hideTime">
                  {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
                </template>
              </div>
            </v-chip>
          </div>
        </template>

        <div v-if="order.IsScheduled">
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }} <br> {{ order.ScheduledDateAt }} {{ order.ScheduledTimeAt }}
        </div>
        <div v-else>
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
          <template v-if="!hideTime">
            <br> {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
          </template>
        </div>
      </v-tooltip>

      <v-tooltip
        v-if="parseInt(order.OrderTypeId) === OrderTypeEnum.SELF_SERVICE && parseInt(order.SourceTypeId) !== SourceTypeEnum.TABLE"
        :color="'teal'"
        :disabled="!tooltip"
        content-class="text-center"
        right
      >
        <template #activator="{on}">
          <div
            class="d-inline-block"
            v-on="on"
          >
            <v-chip
              :class="chipClass"
              :small="dense"
              :style="`min-width: ${chipMinWidth}px;`"
              class="teal lighten-1 white--text elevation-0 pl-0"
              label
            >
              <v-avatar
                :style="avatarSize"
                class="teal darken-1 mr-2"
                tile
              >
                <v-icon
                  :size="iconSize"
                  color="teal lighten-4"
                >
                  mdi-gesture-double-tap
                </v-icon>
              </v-avatar>

              <div
                class="text-center"
                style="width: 100%;"
              >
                <span
                  v-if="label"
                  :class="{'mr-1': !hideTime}"
                >
                  {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
                </span>

                <template v-if="order.IsScheduled">
                  {{ scheduledOrderDate }} {{ order.ScheduledTimeAt }}
                </template>
                <template v-else-if="!hideTime">
                  {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
                </template>
              </div>
            </v-chip>
          </div>
        </template>

        <div v-if="order.IsScheduled">
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }} <br> {{ order.ScheduledDateAt }} {{ order.ScheduledTimeAt }}
        </div>
        <div v-else>
          {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
          <template v-if="!hideTime">
            <br> {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
          </template>
        </div>
      </v-tooltip>

      <v-tooltip
        v-if="parseInt(order.SourceTypeId) === SourceTypeEnum.TABLE"
        :disabled="!tooltip"
        color="brown"
        content-class="text-center"
        right
      >
        <template #activator="{on}">
          <div
            class="d-inline-block"
            v-on="on"
          >
            <v-chip
              :class="chipClass"
              :small="dense"
              :style="`min-width: ${chipMinWidth}px;`"
              class="brown lighten-1 white--text elevation-0 pl-0"
              label
            >
              <v-avatar
                :style="avatarSize"
                class="brown darken-1 mr-2"
                tile
              >
                <v-icon
                  :size="iconSize"
                  class="brown--text text--lighten-4"
                >
                  tab_unselected
                </v-icon>
              </v-avatar>

              <div
                class="text-center"
                style="width: 100%;"
              >
                <span
                  v-if="label"
                  :class="{'mr-1': !hideTime}"
                >
                  {{ getOrderTypeName(order) | uppercase | sanitizeDiacritics }}
                </span>

                <template v-if="!hideTime">
                  {{ convertMinutesToDisplayString(order.TableTime || 1) }}
                </template>
              </div>
            </v-chip>
          </div>
        </template>

        <div>
          <div
            v-if="order.Table"
            class="text-body-2 mb-2"
          >
            {{ order.Table.TableAreaName }} #{{ order.Table.TableName }}
          </div>

          <div
            v-if="order.Persons"
            class="mb-2"
          >
            <strong>{{ $t('Reservation.Table.Headers.Persons') }}</strong>: {{ order.Persons }}
          </div>

          <div
            v-if="order.OrderTotal"
            class="mb-2"
          >
            <strong>{{ $t('Common.Misc.Total') }}</strong>: {{ order.OrderTotal | currency }}
          </div>

          <div
            v-if="order.Persons && order.OrderTotal"
            class="mb-2"
          >
            <strong>{{ $t('Common.Misc.PricePerPerson') }}</strong>: {{ order.OrderTotal / order.Persons | currency }}
          </div>

          <div
            v-if="order.StaffId"
            class=""
          >
            <strong>{{ $tc('Waiter.Title', 1) }}</strong><br>
            <span>{{ order.StaffFirstname + ' ' + order.StaffLastname | sanitizeDiacritics | uppercase }}</span>
          </div>
        </div>
      </v-tooltip>

      <v-avatar
        v-if="order.IsScheduled"
        color="white"
        size="18"
        style="position: absolute; top: -8px; right: -4px;"
      >
        <v-icon
          color="green"
          size="18"
        >
          mdi-clock-time-four
        </v-icon>
      </v-avatar>
    </div>
  </div>
</template>

<script>

import OrderTypeTime from '@/mixins/orders/orderTypeTime'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import OrderType from '@/mixins/orders/orderType'
import OrderTypeEnum from '@/api/Enums/OrderTypeEnum.js'

export default {
  name      : 'OrderTypeChip',
  components: {},
  directives: {},
  mixins    : [OrderType, OrderTypeTime],
  props     : {
    order: {
      type   : Object,
      default: undefined
    },
    minWidth: {
      type   : [Number, String],
      default: 125
    },
    chipClass: {
      type   : String,
      default: 'mx-1'
    },
    label: {
      type   : Boolean,
      default: false
    },
    dense: {
      type   : Boolean,
      default: false
    },
    tooltip: {
      type   : Boolean,
      default: true
    },
    hideTime: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    OrderTypeEnum() {
      return OrderTypeEnum
    },
    SourceTypeEnum() {
      return SourceTypeEnum
    },
    chipMinWidth() {
      return this.minWidth.toString().replaceAll('px', '')
    },
    iconSize() {
      return this.dense ? 18 : 22
    },
    avatarSize() {
      return `width: ${this.dense ? 32 : 46}px !important; height: 32px !important;`
    },

    scheduledOrderDate() {
      const [dateStr, monthStr] = this.order?.ScheduledDateAt?.split('-')
      return this.order?.ScheduledToday ? '' : `${dateStr}/${monthStr}`
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>
:deep(.v-chip > .v-chip__content) {
  width: 100%;
}
</style>
